import { Entity, Field } from "typegraph";

import { Tag } from "./Tag";

// tslint:disable:max-classes-per-file

@Entity({one: "userTag_one", many: "userTag_many"})
export default class UserTag {

	@Field()
	public id: string;

	@Field({entity: Tag})
	public tag: Tag;

}

// TODO - make user tag mutations work with entity response?

@Entity({create: "userTag_save", update: "userTag_save"})
export class UserTagAction {
	@Field() public id: any;
}



// WEBPACK FOOTER //
// ./src/panels/tags/entities/UserTag.ts